/* Model */
class EventTypeModel extends App.Models.BaseModel {
    modelUrl = 'EventType';
}

App.Models.EventType = EventTypeModel;

/* Collection */
class EventTypeCollection extends App.Collections.BaseCollection {
    url = 'EventType';
    model = App.Models.EventType;
}

App.Collections.EventTypes = EventTypeCollection;

/* Router */
class EventTypeRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'EventType';
        const model = App.Models.EventType;
        const collectionClass = App.Collections.EventTypes;

        super(entityName, model, collectionClass);
    }
}

App.Routers.EventType = EventTypeRouter;
